import { useState, useEffect, useCallback } from 'react';
import { timezoneService } from 'api/services/timezoneService';
import type { Timezone } from 'api/types';

export const useTimezones = () => {
  const [data, setData] = useState<Timezone[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchTimezones = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await timezoneService.getAll();
      setData(response.data);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchTimezones(); }, [fetchTimezones]);

  return { data, loading, error, refetch: fetchTimezones };
};
